import React from 'react';

/**
 * 패스워드 공유 기능 섹션 컴포넌트
 */
function ShareSection() {
  return (
    <section id="share" className="guide-section">
      <h2>🔗 패스워드 안전 공유</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>📤 공유 링크 생성</h3>
          <div className="feature-steps">
            <p><strong>기본 공유 방법:</strong></p>
            <ol>
              <li>공유할 패스워드 카드에서 🔗 "공유" 버튼 클릭</li>
              <li>공유 설정 구성:
                <ul>
                  <li><strong>만료 시간:</strong> 1시간 ~ 1주일 선택</li>
                  <li><strong>사용 횟수:</strong> 1회 ~ 20회 선택</li>
                  <li><strong>공유 내용:</strong> 패스워드만 / 패스워드+메모</li>
                </ul>
              </li>
              <li>공유 메모 작성 (선택사항, 최대 200자)</li>
              <li>🔗 "공유 링크 생성" 버튼 클릭</li>
              <li>생성된 링크 자동 복사 또는 📋 수동 복사</li>
            </ol>
            
            <div className="tip-box">
              <strong>💡 팁:</strong> 생성된 링크는 받는 사람이 계정 없이도 접근할 수 있습니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>⚙️ 공유 설정 옵션</h3>
          <div className="feature-steps">
            <p><strong>만료 시간 옵션:</strong></p>
            <ul>
              <li>⏰ 1시간 (긴급한 공유용)</li>
              <li>⏰ 6시간 (당일 업무용)</li>
              <li>⏰ 24시간 (기본 권장)</li>
              <li>⏰ 3일 (프로젝트용)</li>
              <li>⏰ 1주일 (장기 협업용)</li>
            </ul>
            
            <p><strong>사용 횟수 제한:</strong></p>
            <ul>
              <li>1회 (일회성 공유)</li>
              <li>3회 (소규모 팀)</li>
              <li>5회 (기본 권장)</li>
              <li>10회 (중간 규모 팀)</li>
              <li>20회 (대규모 팀)</li>
            </ul>

            <div className="warning-box">
              <strong>⚠️ 보안 권장:</strong> 가능한 짧은 만료 시간과 적은 사용 횟수를 설정하세요.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>📊 공유 이력 관리</h3>
          <div className="feature-steps">
            <p><strong>공유 대시보드 접속:</strong></p>
            <ol>
              <li>상단 메뉴에서 "공유 이력" 버튼 클릭</li>
              <li>또는 ⚙️ 설정 → 공유 관리에서 접속</li>
            </ol>
            
            <p><strong>활성 공유 상태 확인:</strong></p>
            <ul>
              <li>🟢 <strong>활성:</strong> 정상 사용 가능한 공유</li>
              <li>🟠 <strong>경고:</strong> 곧 만료되거나 사용 횟수 부족</li>
              <li>🔵 <strong>완료:</strong> 사용 횟수를 모두 소진한 공유</li>
              <li>⚪ <strong>만료:</strong> 시간 만료된 공유 (자동 정리)</li>
            </ul>

            <p><strong>공유 관리 작업:</strong></p>
            <ul>
              <li>⚡ 즉시 폐기: 위험하거나 불필요한 공유 취소</li>
              <li>🧹 만료된 공유 정리: 자동 또는 수동 일괄 삭제</li>
              <li>📋 공유 메모 확인: 각 공유의 목적 및 대상 확인</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>🛡️ 보안 모범 사례</h3>
          <div className="feature-steps">
            <p><strong>✅ 권장사항:</strong></p>
            <ul>
              <li><strong>최소 권한 원칙:</strong>
                <ul>
                  <li>필요한 최소 시간으로 만료 설정 (가급적 24시간 이하)</li>
                  <li>필요한 최소 횟수로 사용 제한 (가급적 5회 이하)</li>
                </ul>
              </li>
              <li><strong>명확한 목적:</strong>
                <ul>
                  <li>공유 메모에 목적과 대상 명시</li>
                  <li>예: "김철수 대리에게 개발 서버 접속용"</li>
                </ul>
              </li>
              <li><strong>안전한 전달:</strong>
                <ul>
                  <li>신뢰할 수 있는 채널로만 전달</li>
                  <li>전달 후 상대방의 수신 확인</li>
                </ul>
              </li>
            </ul>

            <p><strong>🚨 주의사항:</strong></p>
            <ul>
              <li>❌ 민감한 금융/개인정보 패스워드 공유 금지</li>
              <li>❌ 공개 채팅방이나 이메일 참조 금지</li>
              <li>❌ 불특정 다수에게 공유 금지</li>
              <li>❌ 장기간 유효한 공유 링크 (1주일 초과) 지양</li>
            </ul>

            <div className="tip-box">
              <strong>💡 정기 점검:</strong> 주간 공유 이력 검토 및 불필요한 활성 공유 정리를 권장합니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔒 공유 보안 기술</h3>
          <div className="feature-steps">
            <p><strong>암호화 및 보안:</strong></p>
            <ul>
              <li>🔐 <strong>Web Crypto API:</strong> 브라우저 네이티브 암호화</li>
              <li>🗝️ <strong>AES-256-GCM:</strong> 무결성 보장 암호화</li>
              <li>🔑 <strong>공유용 별도 키:</strong> 원본 데이터와 분리</li>
              <li>⏰ <strong>자동 만료:</strong> 설정 시간 후 완전 삭제</li>
            </ul>

            <p><strong>접속 추적:</strong></p>
            <ul>
              <li>📊 접속 횟수 및 시간 기록</li>
              <li>🚨 비정상 접속 패턴 감지</li>
              <li>🔍 상세 로그 보기 (생성자만)</li>
            </ul>

            <div className="info-box">
              <strong>ℹ️ 기술 정보:</strong> 모든 공유 데이터는 end-to-end 암호화되어 서버에서도 내용을 볼 수 없습니다.
            </div>
          </div>
        </div>
      </div>

      <div className="section-summary">
        <h3>📝 공유 기능 요약</h3>
        <div className="summary-grid">
          <div className="summary-item">
            <span className="summary-icon">🔗</span>
            <div>
              <strong>안전한 공유 링크</strong>
              <p>Web Crypto API 기반 암호화로 안전한 임시 공유</p>
            </div>
          </div>
          <div className="summary-item">
            <span className="summary-icon">⏰</span>
            <div>
              <strong>세밀한 제어</strong>
              <p>만료 시간과 사용 횟수를 자유롭게 설정</p>
            </div>
          </div>
          <div className="summary-item">
            <span className="summary-icon">📊</span>
            <div>
              <strong>실시간 모니터링</strong>
              <p>공유 상태와 사용 현황을 실시간으로 확인</p>
            </div>
          </div>
          <div className="summary-item">
            <span className="summary-icon">🛡️</span>
            <div>
              <strong>엔터프라이즈급 보안</strong>
              <p>접속 로깅, 자동 만료, 즉시 폐기 기능</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ShareSection;
